

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface CourierMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface CourierMst {
    id?:number;
    courierCode:string;
    courierName:string;
    courierTrackingURL:string;
    courierPhone:string;
    courierContactName:string;
    courierMobile:string;
    courierEmail:string;
    courierAddress1:string;
    courierAddress2:string;
    courierCity:string;
    courierPincode:string;
    courierDistrict:string;
    courierState:string;
    courierCountry:string;
    createdBy:number;
    createdDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: CourierMstParameter[];
    links?: any;
}

export abstract class CourierMstData { 
    abstract list(url: string): Observable<CourierMst[]>;
    abstract create(url: string,data: CourierMst): Observable<any>;
    abstract update(url: string,data: CourierMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
